import Utils from '../utils/utils'
import Manifest from '../core/manifest'

/**
 * Инициализация дополнительных библиотек
 * @returns {void}
 */
function init() {
    let include = []

    // Видео библиотеки
    include = include.concat(['hls/hls.js', 'dash/dash.js', 'qrcode/qrcode.js'].map(lib => {
        return window.location.protocol == 'file:' || window.location.href.indexOf('chrome-extension') > -1 ? Manifest.github_lampa + 'vender/' + lib : './vender/' + lib
    }))

    // YouTube IFrame API
    // больше не актуально, так как youtube плеер теперь использует собственный мост для взаимодействия с iframe, и не зависит от глобального объекта YT
    // if(window.youtube_lazy_load && window.lampa_settings.youtube){
    //     include.push(Utils.protocol() + 'youtube.com/iframe_api')
    // }

    // Плагины различные
    if (!window.lampa_settings.iptv && window.lampa_settings.services) {
        include.push(Utils.protocol() + Manifest.cub_domain + '/plugin/sport')
        include.push(Utils.protocol() + Manifest.cub_domain + '/plugin/tsarea')
    }

    // Плагин Shots
    // if(window.location.hostname !== 'localhost' && !window.lampa_settings.iptv) include.push(Utils.protocol() + Manifest.cub_domain + '/plugin/shots')


    Utils.putScriptAsync(include, () => { })
}

export default {
    init
}